import {z} from "zod/v4";
import {BoxProps} from "@mui/joy";

export type SxProps = BoxProps["sx"];

export function mergeSx(...sxen: (SxProps | null | undefined)[]): SxProps {
    const rv = [];
    for (const sx of sxen) {
        if (!sx) {
            continue;
        }
        if (Array.isArray(sx)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            rv.push(...sx);
        } else {
            rv.push(sx);
        }
    }
    return rv as SxProps;
}

export const JoyPalette = z.literal([
    "neutral", "primary", "secondary", "tertiary", "success", "warning", "danger"
]);

export const JoyVariant = z.literal([
    "plain", "solid", "soft", "outlined"
]);

export const SxProps: z.ZodType<SxProps> = z.any();

export const Joyable = z.object({
   sx: z.optional(SxProps),
   color: z.optional(JoyPalette),
   variant: z.optional(JoyVariant),
});
export type Joyable = z.infer<typeof Joyable>;

// export const ReactNode: z.ZodType<ReactNode> = z.any();
